import React from "react";
// import { LESSONS_PLAN } from 'constants/routes';
// import { Link } from 'gatsby';
import PropTypes from "prop-types";
import lang from "./lang";
import { navigateToLessonsPlan } from "utils/navigateToLessonsPlan";

import "./styles.scss";

const Header = ({ lessonNumber, type, baseUrl }) => {
  return lessonNumber && type !== 'demo' ? (
    <div className="header">
      <span>
        <strong>
          {lang?.lesson} {lessonNumber}:
        </strong>{" "}
        {lang?.taskDescriptions[type]}
      </span>
      <div
        className="close-button"
        onClick={() => navigateToLessonsPlan(baseUrl)}
      >
        &nbsp;
      </div>
    </div>
  ) : null;
};

Header.propTypes = {
  lessonNumber: PropTypes.number,
  type: PropTypes.string.isRequired,
};

export default Header;
